import './select-supported-countries.modal.scss';

export default function SelectSupportedCountriesModal($scope, countries, $alert, close) {
  'ngInject';

  $scope.selectCountry = {
    countries: countries,
    country: undefined
  };

  $scope.mapCountryValue = country => {
    if (country) {
      return country.name;
    }

    return country;
  }

  $scope.ok = (form) => {
    if (!$scope.selectCountry.country) {
      $alert.error("Select country when you registered your bnk account");
      return;
    }

    close($scope.selectCountry.country);
  }

  $scope.close = () => {
    close(false);
  }
}